import React from "react";
import { ButtonContainer } from "./style";

const Button = ({ children, ...rest }) => (
    <ButtonContainer cardAvaliacao={rest.cardAvaliacao} {...rest}>{children}</ButtonContainer>
);

export default Button;
